var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d8d0",
    d: "M16 0A16 16 0 0 0 0 16a16 16 0 0 0 16 16 16 16 0 0 0 16-16A16 16 0 0 0 16 0m0 7a4 4 0 0 1 4 4 4 4 0 0 1-4 4 4 4 0 0 1-4-3.5A4 4 0 0 1 16 7m0 9.5a8 8 0 0 1 8 7.5H8a8 8 0 0 1 8-7.5"
  })));
};
export default SvgProfile;